let user = document.head.querySelector('meta[name="user"]');
let permisos = document.head.querySelector('meta[name="permisos"]');
let restrictedAccess = document.head.querySelector('meta[name="restricted-access"]');
let arreglo=[];

module.exports = {
    computed: {
        user(){
            return JSON.parse(user.content);
        },
        hasRestrictedAccess(){
            return Boolean(restrictedAccess && restrictedAccess.content === '1');
        },
        permisos(){
            //console.log(permisos.content);
            JSON.parse(permisos.content).forEach(element => {
                arreglo.push(element.codigo)
            });
            return arreglo;
        }
    },
    methods: {
        hasPermission(permission) {//funciones que se pueden llamar desde cualquier componente de vue
            console.log('funcion hasPermission de prueba ',arreglo);
            return true
        }
    },
    isAuthenticated() {
        return !! user.content;
    },
    guest() {
        return ! this.isAuthenticated;
    },

}